export default __webpack_public_path__ + "static/media/feature-tile-icon-04.1acd4dac.svg";